import { memo } from "react";
import { type PdpPageProductData } from "../../../models/PdpPageProductData";
import EmptyCadTab from "./EmptyCadTab";
import ConfiguredCadTabV2 from "./ConfiguredCadTabV2";
import { ExternalBrand } from "~/dto/ProductDataDTO";
import { EwellixCadTab } from "~/ProductDetails/components/PdpTabs/CadTab/EwellixCadTab";

export interface CadTabProps {
  product: Pick<
    PdpPageProductData,
    | "designation"
    | "tracePartsOrderNo"
    | "tracePartsUrl"
    | "customerRequestedCADAvailability"
    | "code"
    | "externalBrand"
  >;
}

const CadTab = (props: CadTabProps) => {
  const isCADConfigured = !!props.product.tracePartsUrl;

  if (isCADConfigured) {
    if (props.product.externalBrand === ExternalBrand.Ewellix) {
      return <EwellixCadTab url={props.product.tracePartsUrl} />;
    } else {
      return <ConfiguredCadTabV2 {...props} />;
    }
  } else {
    return <EmptyCadTab {...props} />;
  }
};

export default memo(CadTab);
